import React from "react";
import "./Logo.scss";
import logoImage from "../../../assets/images/Logo.png";

const Logo = () => {
  return (
    <div className="logo-container">
      <img src={logoImage} alt="Logo" draggable={false} />
    </div>
  );
};

export default Logo;
